import classNames from "classnames";
import React, { useCallback, useMemo } from "react";
import { Item } from "./Item";
import "../styles/index.css";
import { Line } from "./Line";
import { fixEarthlyBranchIndex } from "iztro/lib/utils";
import { normalizeDateStr, solar2lunar } from "lunar-lite";
import { kot, t } from "iztro/lib/i18n";
import { CHINESE_TIME } from "iztro/lib/data";
export const IzpalaceCenter = ({ astrolabe, horoscope, arrowIndex, arrowScope, horoscopeDate = new Date(), horoscopeHour = 0, setHoroscopeDate, setHoroscopeHour, centerPalaceAlign, }) => {
    const records = useMemo(() => [
        {
            title: "五行局：",
            content: astrolabe?.fiveElementsClass,
        },
        {
            title: "年龄(虚岁)：",
            content: `${horoscope?.age.nominalAge} 岁`,
        },
        {
            title: "四柱：",
            content: astrolabe?.chineseDate,
        },
        {
            title: "阳历：",
            content: astrolabe?.solarDate,
        },
        {
            title: "农历：",
            content: astrolabe?.lunarDate,
        },
        {
            title: "时辰：",
            content: `${astrolabe?.time}(${astrolabe?.timeRange})`,
        },
        {
            title: "生肖：",
            content: astrolabe?.zodiac,
        },
        {
            title: "星座：",
            content: astrolabe?.sign,
        },
        {
            title: "命主：",
            content: astrolabe?.soul,
        },
        {
            title: "身主：",
            content: astrolabe?.body,
        },
        {
            title: "命宫：",
            content: astrolabe?.earthlyBranchOfSoulPalace,
        },
        {
            title: "身宫：",
            content: astrolabe?.earthlyBranchOfBodyPalace,
        },
    ], [astrolabe, horoscope]);
    const horoDate = useMemo(() => {
        const dateStr = horoscopeDate ?? new Date();
        const [year, month, date] = normalizeDateStr(dateStr);
        const dt = new Date(year, month - 1, date);
        return {
            solar: `${year}-${month}-${date}`,
            lunar: solar2lunar(dateStr).toString(true),
            prevDecadalDisabled: dt.setFullYear(dt.getFullYear() - 1),
        };
    }, [horoscopeDate]);
    const onHoroscopeButtonClicked = (scope, value) => {
        if (!astrolabe?.solarDate) {
            return true;
        }
        const [year, month, date] = normalizeDateStr(horoscopeDate);
        const dt = new Date(year, month - 1, date);
        const [birthYear, birthMonth, birthDate] = normalizeDateStr(astrolabe.solarDate);
        const birthday = new Date(birthYear, birthMonth - 1, birthDate);
        let hour = horoscopeHour;
        switch (scope) {
            case "hourly":
                hour = horoscopeHour + value;
                if (horoscopeHour + value > 11) {
                    // 如果大于亥时，则加一天，时辰变为早子时
                    dt.setDate(dt.getDate() + 1);
                    hour = 0;
                }
                else if (horoscopeHour + value < 0) {
                    // 如果小于早子时，则减一天，时辰变为亥时
                    dt.setDate(dt.getDate() - 1);
                    hour = 11;
                }
                break;
            case "daily":
                dt.setDate(dt.getDate() + value);
                break;
            case "monthly":
                dt.setMonth(dt.getMonth() + value);
                break;
            case "yearly":
            case "decadal":
                dt.setFullYear(dt.getFullYear() + value);
                break;
        }
        if (dt.getTime() >= birthday.getTime()) {
            setHoroscopeDate?.(dt);
            setHoroscopeHour?.(hour);
        }
    };
    const shouldBeDisabled = useCallback((dateStr, scope, value) => {
        if (!astrolabe?.solarDate) {
            return true;
        }
        const [year, month, date] = normalizeDateStr(dateStr);
        const dt = new Date(year, month - 1, date);
        const [birthYear, birthMonth, birthDate] = normalizeDateStr(astrolabe.solarDate);
        const birthday = new Date(birthYear, birthMonth - 1, birthDate);
        switch (scope) {
            case "hourly":
                if (horoscopeHour + value > 11) {
                    dt.setDate(dt.getDate() + 1);
                }
                else if (horoscopeHour + value < 0) {
                    dt.setDate(dt.getDate() - 1);
                }
                break;
            case "daily":
                dt.setDate(dt.getDate() + value);
                break;
            case "monthly":
                dt.setMonth(dt.getMonth() + value);
                break;
            case "yearly":
            case "decadal":
                dt.setFullYear(dt.getFullYear() + value);
                break;
        }
        if (dt.getTime() < birthday.getTime()) {
            return true;
        }
        return false;
    }, [horoscopeHour, astrolabe]);
    return (React.createElement("div", { className: classNames("iztro-center-palace", {
            "iztro-center-palace-centralize": centerPalaceAlign,
        }) },
        astrolabe?.earthlyBranchOfSoulPalace && (React.createElement(Line, { scope: arrowScope, index: arrowIndex ??
                fixEarthlyBranchIndex(astrolabe.earthlyBranchOfSoulPalace) })),
        React.createElement("h3", { className: "center-title" },
            React.createElement("span", { className: `gender gender-${kot(astrolabe?.gender ?? "")}` }, kot(astrolabe?.gender ?? "") === "male" ? "♂" : "♀"),
            React.createElement("span", null, "\u57FA\u672C\u4FE1\u606F")),
        React.createElement("ul", { className: "basic-info" }, records.map((rec, idx) => (React.createElement(Item, { key: idx, ...rec })))),
        React.createElement("h3", { className: "center-title" }, "\u8FD0\u9650\u4FE1\u606F"),
        React.createElement("ul", { className: "basic-info" },
            React.createElement(Item, { title: "\u519C\u5386\uFF1A", content: horoDate.lunar }),
            React.createElement("div", { className: classNames("solar-horoscope", {
                    "solar-horoscope-centralize": centerPalaceAlign,
                }) },
                React.createElement(Item, { title: "\u9633\u5386\uFF1A", content: horoDate.solar }),
                React.createElement("span", { className: "today", onClick: () => setHoroscopeDate?.(new Date()) }, "\u4ECA"))),
        React.createElement("div", { className: "horo-buttons" },
            React.createElement("span", { className: classNames("center-button", {
                    disabled: shouldBeDisabled(horoDate.solar, "yearly", -10),
                }), onClick: () => onHoroscopeButtonClicked("yearly", -10) }, "\u25C0\u9650"),
            React.createElement("span", { className: classNames("center-button", {
                    disabled: shouldBeDisabled(horoDate.solar, "yearly", -1),
                }), onClick: () => onHoroscopeButtonClicked("yearly", -1) }, "\u25C0\u5E74"),
            React.createElement("span", { className: classNames("center-button", {
                    disabled: shouldBeDisabled(horoDate.solar, "monthly", -1),
                }), onClick: () => onHoroscopeButtonClicked("monthly", -1) }, "\u25C0\u6708"),
            React.createElement("span", { className: classNames("center-button", {
                    disabled: shouldBeDisabled(horoDate.solar, "daily", -1),
                }), onClick: () => onHoroscopeButtonClicked("daily", -1) }, "\u25C0\u65E5"),
            React.createElement("span", { className: classNames("center-button", {
                    disabled: shouldBeDisabled(horoDate.solar, "hourly", -1),
                }), onClick: () => onHoroscopeButtonClicked("hourly", -1) }, "\u25C0\u65F6"),
            React.createElement("span", { className: "center-horo-hour" }, t(CHINESE_TIME[horoscopeHour])),
            React.createElement("span", { className: classNames("center-button"), onClick: () => onHoroscopeButtonClicked("hourly", 1) }, "\u65F6\u25B6"),
            React.createElement("span", { className: classNames("center-button"), onClick: () => onHoroscopeButtonClicked("daily", 1) }, "\u65E5\u25B6"),
            React.createElement("span", { className: classNames("center-button"), onClick: () => onHoroscopeButtonClicked("monthly", 1) }, "\u6708\u25B6"),
            React.createElement("span", { className: classNames("center-button"), onClick: () => onHoroscopeButtonClicked("yearly", 1) }, "\u5E74\u25B6"),
            React.createElement("span", { className: classNames("center-button"), onClick: () => onHoroscopeButtonClicked("yearly", 10) }, "\u9650\u25B6"))));
};
